import metaPageInfo from './metaPageInfo'
const LogLevel = require('archii-web-components').Logger.Level

const S3Link =  'https://s3.eu-central-1.amazonaws.com/archii.client/'


const getDownloadLinks = (environment) => {
    const mac = `${S3Link}Staging+DataMapper-5.1.0.dmg`
    const win = `${S3Link}Staging+DataMapper+Setup+5.1.0.exe`
    return {
        mac,
        win
    }
}



const production = {
    downloadLinks: getDownloadLinks(''),
    baseURI: 'https://api.archii.ai/api',
    hbspDemoLink: 'https://app.hubspot.com/meetings/air1',
    metaPageInfo,
    googleAnalyticsId: 'UA-108054246-1',
    debugAnalytics: false,
    logLevel: LogLevel.NONE,
    traceLevel: LogLevel.NONE,
}

const dev = Object.assign({}, production, {
    baseURI: 'http://localhost/api',
    logLevel: LogLevel.ALL,
    traceLevel: LogLevel.ALL,
    // debugAnalytics: true
})


const staging = Object.assign({}, production, {
    downloadLinks: getDownloadLinks('-staging'),
    logLevel: LogLevel.ALL,
    traceLevel: LogLevel.ALL,
    baseURI: 'https://api-staging.archii.ai/api'
})

const test = Object.assign({}, production, {
    downloadLinks: getDownloadLinks('-test-server'),
    baseURI: 'https://api-test.archii.ai/api'
})

const configs = {
    dev,
    production,
    staging,
    test
}

const config = configs[ARCHII_ENV]


export default config



// WEBPACK FOOTER //
// ./config/index.js